export default {
  partner:
    'Aseta Stripe-käsittelymaksusi tai vahvista 0 %:n marginaali. Siihen asti Stripeä käyttävät ravintolasi eivät voi aloittaa toimintaansa.',
  partner_live_one:
    'Aseta Stripe-käsittelymaksusi tai vahvista 0 %:n marginaali. Siihen asti Stripeä käyttävät ravintolasi eivät voi aloittaa toimintaansa, eikä toiminnassa oleva ravintolasi ota vastaan verkkomaksuja.',
  partner_live_other:
    'Aseta Stripe-käsittelymaksusi tai vahvista 0 %:n marginaali. Siihen asti Stripeä käyttävät ravintolasi eivät voi aloittaa toimintaansa, eivätkä {{count}} toiminnassa olevaa ravintolaasi ota vastaan verkkomaksuja.',
  restaurant: 'Verkkomaksut on keskeytetty, kunnes kumppanisi asettaa käsittelymaksun. Käteismaksut toimivat edelleen.',
  cta: 'Aseta käsittelymaksu',
};
